import React, { useState } from 'react';
import '../styles/PlanSelectionForm.css';

const PlanSelectionForm = ({ onPlanSelect, initialPlan }) => {
  const [selectedPlan, setSelectedPlan] = useState(initialPlan || '');

  const planOptions = [
    { value: 'titular-sin-cargas', label: 'Titular sin cargas', description: 'Cobertura individual' },
    { value: 'titular-1-carga', label: 'Titular + 1 carga', description: 'Cobertura para 2 personas' },
    { value: 'titular-2-cargas', label: 'Titular + 2 cargas', description: 'Cobertura para 3 personas' },
    { value: 'titular-3-cargas', label: 'Titular + 3 cargas', description: 'Cobertura para 4 personas' },
    { value: 'titular-4-mas-cargas', label: 'Titular + 4 o más cargas', description: 'Cobertura para 5 o más personas' }
  ];

  const handlePlanChange = (event) => {
    const plan = event.target.value;
    setSelectedPlan(plan);
    if (onPlanSelect) {
      onPlanSelect(plan);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!selectedPlan) {
      alert('Por favor seleccione un plan');
      return;
    }
    console.log('Plan seleccionado:', selectedPlan);
  };

  return (
    <div className="plan-selection-container">
      <div className="form-header">
        <h1>Pre-inscripción Seguro Complementario de Salud</h1>
        <h2>Colegio de Ingenieros</h2>
        <p>Seleccione el plan que mejor se adapte a sus necesidades</p>
      </div>

      <form onSubmit={handleSubmit} className="plan-selection-form">
        <div className="plan-options">
          <label htmlFor="plan-select" className="select-label">
            Seleccione su plan:
          </label>
          <select 
            id="plan-select"
            value={selectedPlan} 
            onChange={handlePlanChange}
            className="plan-select"
          >
            <option value="">-- Seleccione un plan --</option>
            {planOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label} - {option.description}
              </option>
            ))}
          </select>
        </div>

        <div className="form-actions">
          <button 
            type="submit" 
            className="continue-btn"
            disabled={!selectedPlan}
          >
            Continuar
          </button>
        </div>
      </form>
    </div>
  );
};

export default PlanSelectionForm;